import { Row } from 'reactstrap';
import styled from 'styled-components';

export const AppRow = styled(Row)`
  padding-top: 55px;
`;

export const PageRow = styled(Row).attrs({
  className: 'my-2'
})``;

export const DisableCopy = `
  user-select: none;
`;



// WEBPACK FOOTER //
// ./src/components/style/Rows.style.js